"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const theme = {
    spacing: 8,
    shape: {
        borderRadius: 12,
    },
    shadows: [
        'none',
        '0 16px 40px -12.125px rgba(0,0,0,0.3)',
        '0 16px 40px -12.125px rgba(0,0,0,0.3)',
    ],
    props: {
        // Name of the component ⚛️
        MuiButtonBase: {
        // The default props to change
        //   disableRipple: true, // No more ripple, on the whole application 💣!
        },
        MuiButton: {
            disableElevation: true,
        },
        MuiCard: {
            elevation: 1,
        },
        MuiTooltip: {
            elevation: 1,
        },
        MuiSlider: {
            valueLabelDisplay: 'off',
        },
    },
};
exports.default = theme;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2VuZXJhbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9nZW5lcmFsLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsTUFBTSxLQUFLLEdBQUc7SUFDWixPQUFPLEVBQUUsQ0FBQztJQUNWLEtBQUssRUFBRTtRQUNMLFlBQVksRUFBRSxFQUFFO0tBQ2pCO0lBQ0QsT0FBTyxFQUFFO1FBQ1AsTUFBTTtRQUNOLHVDQUF1QztRQUN2Qyx1Q0FBdUM7S0FDeEM7SUFDRCxLQUFLLEVBQUU7UUFDTCwyQkFBMkI7UUFDM0IsYUFBYSxFQUFFO1FBQ2IsOEJBQThCO1FBQzlCLHlFQUF5RTtTQUMxRTtRQUNELFNBQVMsRUFBRTtZQUNULGdCQUFnQixFQUFFLElBQUk7U0FDdkI7UUFDRCxPQUFPLEVBQUU7WUFDUCxTQUFTLEVBQUUsQ0FBQztTQUNiO1FBQ0QsVUFBVSxFQUFFO1lBQ1YsU0FBUyxFQUFFLENBQUM7U0FDYjtRQUNELFNBQVMsRUFBRTtZQUNULGlCQUFpQixFQUFFLEtBQUs7U0FDekI7S0FDRjtDQUNGLENBQUM7QUFFRixrQkFBZSxLQUFLLENBQUMifQ==